import { useCallback, useEffect, useRef, useState } from 'react';
import { searchStoreList, StoreInfo } from 'services/api/store';

const useStoreList = (
  regionList: General.UpperCaseRegion[],
  platform?: General.PlatformUpperCase,
) => {
  const currentPageRef = useRef(0);
  const [list, setList] = useState<StoreInfo[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const fetchList = useCallback(
    (keyword?: string) => {
      if (!platform) {
        return;
      }
      const regions = regionList.length === 0 ? undefined : regionList;
      setLoading(true);
      searchStoreList({
        regions,
        platform,
        keyword,
        cursor: currentPageRef.current,
        page_size: 20,
      })
        .then((res) => {
          currentPageRef.current += 1;
          setList((pre) => [...pre, ...res.data.data.data]);
          setHasMore(res.data.data.hasNext);
        })
        .finally(() => setLoading(false));
    },
    [platform, regionList],
  );
  const onSearch = useCallback(
    (keyword: string) => {
      currentPageRef.current = 1;
      setList([]);
      fetchList(keyword);
    },
    [fetchList],
  );
  useEffect(() => {
    currentPageRef.current = 1;
    setList([]);
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platform, regionList]);
  return {
    list,
    loadMore: fetchList,
    loading,
    onSearch,
    hasMore,
  };
};

export default useStoreList;
